import { createSlice } from '@reduxjs/toolkit';
import { GetMapResponse, SiteItem } from 'types';
import { getMapSite, getUserSiteAgent, getUserSiteCharge } from './thunk';

interface InitialState {
  sitesAgent: {
    sites: SiteItem[] | null;
    loading: boolean;
  };
  sitesCharge: {
    sites: SiteItem[] | null;
    loading: boolean;
  };
  loading: boolean;
  siteLoading: boolean;
  map: GetMapResponse | null;
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
  error_message: string;
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
}

const initialState: InitialState = {
  sitesAgent: {
    sites: null,
    loading: false,
  },
  sitesCharge: {
    sites: null,
    loading: false,
  },
  loading: false,
  siteLoading: false,
  map: null,
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
  error_message: '',
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
};

export const supportSiteListSlice = createSlice({
  name: '/user/sites',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getUserSiteCharge.pending, (state) => {
      state.sitesCharge.sites = initialState.sitesCharge.sites;
      state.sitesCharge.loading = true;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
      state.error_message = '';
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
    });
    builder.addCase(getUserSiteCharge.fulfilled, (state, { payload }) => {
      state.sitesCharge.sites = payload.sites;
      state.sitesCharge.loading = false;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
      state.error_message = '';
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
    });
    builder.addCase(getUserSiteCharge.rejected, (state, payload: any) => {
      state.sitesCharge.sites = initialState.sitesCharge.sites;
      state.sitesCharge.loading = false;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
      state.error_message = payload?.payload?.response?.data?.message || payload.error.message;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
    });

    builder.addCase(getUserSiteAgent.pending, (state) => {
      state.sitesAgent.sites = initialState.sitesAgent.sites;
      state.sitesAgent.loading = true;
    });
    builder.addCase(getUserSiteAgent.fulfilled, (state, { payload }) => {
      state.sitesAgent.sites = payload.sites;
      state.sitesAgent.loading = false;
    });
    builder.addCase(getUserSiteAgent.rejected, (state) => {
      state.sitesAgent.sites = initialState.sitesAgent.sites;
      state.sitesAgent.loading = false;
    });

    //map
    builder.addCase(getMapSite.pending, (state) => {
      state.loading = true;
      state.error_message = '';
    });
    // builder.addCase(getMapSite.fulfilled, (state, { payload }) => {
    builder.addCase(getMapSite.fulfilled, (state, action) => {
      state.map = action.payload;
      state.loading = false;
      state.error_message = '';
    });
    // builder.addCase(getMapSite.rejected, (state) => {
    builder.addCase(getMapSite.rejected, (state, action) => {
      state.map = initialState.map;
      state.loading = false;
      state.error_message =
        (action.payload as any)?.response?.data?.message ??
        (action.payload as any)?.zOthers?.data?.message ??
        (action.payload as any)?.message ??
        (action.payload as any)?.err?.message ??
        action.error?.message ??
        'エラーが発生しました。';
    });
  },
});

export default supportSiteListSlice.reducer;
